import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase auto-exchanges the ?code= param on load (detectSessionInUrl is enabled).
    // We just need to wait for the SIGNED_IN event to confirm and then navigate.
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_IN') {
        navigate('/', { replace: true });
      } else if (event === 'INITIAL_SESSION') {
        const hasOAuthCode = new URLSearchParams(window.location.search).has('code');
        if (!hasOAuthCode) {
          navigate('/', { replace: true });
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-[#cfef00] animate-pulse" />
        <p className="text-[#cfef00] text-sm font-medium">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
